import React from 'react';
import { ratingTypes } from '../../../utils/constants';
import styles from '../../../pages/SearchPage/search.scss';

const StandingsHeaderColumns = ({ 'data-testid': dataTestId }) => {
    return (
        <div className={`${styles.searchHeaders} d-none d-md-flex`} data-testid={dataTestId}>
            <div className="flex-grow">
                <div className="row">
                    <div className={`col-sm-4`} data-testid={dataTestId ? `${dataTestId}.name` : undefined}>
                        Name
                    </div>
                    <div className="col-md-8">
                        <div className="row w-100">
                            <div className={`col`} data-testid={dataTestId ? `${dataTestId}.rating` : undefined}>
                                {ratingTypes.tennis}
                            </div>
                            <div className={`col text-center`} data-testid={dataTestId ? `${dataTestId}.matches` : undefined}>
                                Matches
                            </div>
                            <div className={`col text-center`} data-testid={dataTestId ? `${dataTestId}.record` : undefined}>
                                Record
                            </div>
                            <div className={`col text-center`} data-testid={dataTestId ? `${dataTestId}.sets` : undefined}>
                                Sets
                            </div>
                            <div className={`col text-center`} data-testid={dataTestId ? `${dataTestId}.games` : undefined}>
                                Games
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StandingsHeaderColumns;
